module.exports = "/images/gf.svg?75db70d5c52714416d2d34a6dd9175d0";